let color1 = '#32ff7e';
let color2 = '#D91E18';
let color3 = '#3ae374';
let color4 = '#EC644B';
let istatistikObj = [
  {
    name: "Havuzsuyu",
    statename: "havuzsuyu",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Gıda",
    statename: "gida",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Havuzsuyu Mikrobiyoloji",
    statename: "huvuzsuyumikro",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Kimyasal",
    statename: "kimyasal",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Legionella",
    statename: "legionella",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Su Özel",
    statename: "suozel",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Swab",
    statename: "swab",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Mantar",
    statename: "mantar",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Ortam Petrisi",
    statename: "ortam",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Deniz Suyu",
    statename: "denizsuyu",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "Sıvı",
    statename: "sivi",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  },
  {
    name: "H.Suyu Mikro.Kim.",
    statename: "havuzsuyumikrokimyasal",
    labels: [
      'Olumlu',
      'Olumsuz'
    ],
    datasets: [{
      data: [0, 0],
      backgroundColor: [
        color1,
        color2
      ],
      hoverBackgroundColor: [
        color3,
        color4
      ]
    }]
  }
];
export default istatistikObj;